import { api, ApiError } from '@/lib/api';
import type { GateReport } from '@/types';

/**
 * Fetch a job's gate report, tolerating the two "not ready" states:
 * 202 (pipeline still running, no synthesised report yet) and 404 (no
 * report row) both resolve to null so callers can render a placeholder.
 * Any other error propagates. Shared by JobDetailPage and ContractDetailPage.
 */
export async function fetchReport(jobId: string): Promise<GateReport | null> {
  try {
    return await api.get<GateReport>(`/api/v1/jobs/${jobId}/report`);
  } catch (err) {
    if (err instanceof ApiError && (err.status === 202 || err.status === 404)) {
      return null;
    }
    throw err;
  }
}
